import { action } from 'satcheljs/lib/legacy';
import { findComposePlugins } from '../plugins/ComposePlugins';
export default action('preloadComposePlugins')(function preloadComposePlugins(viewState) {
    var plugins = findComposePlugins(viewState);
    if (plugins) {
        if (plugins.atMentionsPlugin &&
            viewState.atMentions.atMentionTuples &&
            Object.keys(viewState.atMentions.atMentionTuples).length > 0) {
            plugins.atMentionsPlugin.getPlugin();
        }
    }
});
//# sourceMappingURL=preloadComposePlugins.js.map